import { useEffect, useState } from "react";
import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { SelectModal } from "../SelectModal";
import IconButton from "@mui/material/IconButton";
import CancelIcon from '@mui/icons-material/Cancel';
import AssessmentIcon from '@mui/icons-material/Assessment';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface ISelectChipProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    client: string,
    currentSelection?: any,
    show: boolean;
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];
    isAgent: boolean;
    fetchOptions?: (controller: string, action: string, setData: (data: any) => void) => void;
    fetchOptionsController?: string;
    fetchOptionsAction?: string;
    options?: any[];
    multiSelect?: boolean;
    searchable?: boolean;
    showOnReport?: boolean;
}

export default function SelectChip(props: ISelectChipProps) {
    const [options, setOptions] = useState<any>(props.options ?? []);

    useEffect(() => {
        if (props.options)
            setOptions(props.options)
    }, [props.options])

    useEffect(() => {
        if (props.fetchOptions) {
            fetchOptions();
        }
    }, []);

    const fetchOptions = () => {
        if (props.fetchOptionsController && props.fetchOptionsAction) {
            props.fetchOptions!(props.fetchOptionsController, props.fetchOptionsAction, setOptions);
        }
        else throw Error('Cannot invoke fetchOptions without providing both a controller and action as SelectChip properties');
    }

    const handleSelect = (name: any, value: any) => props.onSelect(name, value);

    const handleDelete = () => {
        if (props.removeFilter !== null && props.removeFilter !== undefined) {
            props.removeFilter(props.filterFlag, props.filterNames);
        }
    }

    return (
        <>
            {
                props.show &&
                <Grid>
                    <Grid container sx={styles.root} justifyContent="space-between" alignItems="center">
                        {props.showOnReport &&
                            <AssessmentIcon sx={{ ml: 1 }} />
                        }
                        <Grid sx={styles.text}>
                            <Typography variant="body1">{props.title}</Typography>
                        </Grid>
                        <SelectModal
                            title={props.title}
                            filterName={props.filterName}
                            mutliSelect={props.multiSelect ?? false}
                            currentSelection={props.currentSelection}
                            onSelect={handleSelect}
                            options={options}
                            searchable={props.searchable ?? false}
                            isAgent={props.isAgent}
                        />
                        <Grid>
                            {props.removeFilter !== null && props.removeFilter !== undefined &&
                                <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={styles.button}>
                                    <CancelIcon />
                                </IconButton>
                            }
                        </Grid>
                    </Grid>
                </Grid >
            }
        </>

    );
}